import type { ComponentType } from 'preact'
import { useChunk } from '../ui/useChunk'
import { useStore } from '../ui/useStore'
import type { Party } from './party'
import type * as BarChunk from './PartyBar'
import type { PartyBarProps } from './PartyBar'
import type * as PanelChunk from './PartyPanel'

type PanelModule = typeof PanelChunk
type BarModule = typeof BarChunk

const panelChunk: { m: PanelModule | null } = { m: null }
const barChunk: { m: BarModule | null } = { m: null }
const loadPanel = () => import('./PartyPanel')
const loadBar = () => import('./PartyBar')

/**
 * D-053 slot `party.Panel` (T2.7) as a synchronous, prop-less component: its code loads the
 * first time it mounts (the hub's Play with friends popover), so the menu's initial JS stays small.
 */
export function makePartyPanel(party: Party): ComponentType {
  return function PartyPanel() {
    const mod = useChunk(true, loadPanel, panelChunk)
    return mod ? <mod.PartyPanelView party={party} /> : null
  }
}

/** The party bar (over the hub and the results): nothing outside a party. */
export function makePartyBar(party: Party): ComponentType<PartyBarProps> {
  return function PartyBar({ place = 'top' }: PartyBarProps) {
    const view = useStore(party.state)
    const mod = useChunk(view !== null, loadBar, barChunk)
    return view && mod ? <mod.PartyBarView party={party} view={view} place={place} /> : null
  }
}
